export default __webpack_public_path__ + "static/media/ReamingImg.086925c0.jpg";